/* eslint-disable global-require */
module.exports = ['search.inputs.date.popup.m3'];
